/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConclusionGroup } from './ConclusionGroup';
import {
    ConclusionGroupFromJSON,
    ConclusionGroupFromJSONTyped,
    ConclusionGroupToJSON,
    ConclusionGroupToJSONTyped,
} from './ConclusionGroup';
import type { UiIdentifier } from './UiIdentifier';
import {
    UiIdentifierFromJSON,
    UiIdentifierFromJSONTyped,
    UiIdentifierToJSON,
    UiIdentifierToJSONTyped,
} from './UiIdentifier';
import type { ExprCclRef } from './ExprCclRef';
import {
    ExprCclRefFromJSON,
    ExprCclRefFromJSONTyped,
    ExprCclRefToJSON,
    ExprCclRefToJSONTyped,
} from './ExprCclRef';

/**
 * SubstanceAdministrationPrescription expression enriched with computed UI fields.
 * Contains all Expression fields plus icon, order, text and id.
 * 
 * @export
 * @interface SapExpression
 */
export interface SapExpression {
    /**
     * 
     * @type {number}
     * @memberof SapExpression
     */
    expressionId: number;
    /**
     * 
     * @type {number}
     * @memberof SapExpression
     */
    conceptGroupId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    originalText?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    matchedText?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    unMatchedText?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    multiDosageText?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    metaDataText?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    languageIso?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SapExpression
     */
    isMatched: boolean;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    expressionType: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    siteRoot?: string;
    /**
     * Computed anatomical family group (Pain, Cardio, Neuro, …)
     * @type {string}
     * @memberof SapExpression
     */
    siteRootGroup?: string;
    /**
     * Sort index of siteRootGroup
     * @type {number}
     * @memberof SapExpression
     */
    siteRootGroupIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    aggressorRoot?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    aggressorRootGroup?: string;
    /**
     * 
     * @type {Date}
     * @memberof SapExpression
     */
    timelineStart?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SapExpression
     */
    timelineEnd?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    durationType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SapExpression
     */
    isNegated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SapExpression
     */
    isFamilyHistory?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SapExpression
     */
    isFact?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SapExpression
     */
    isNumerical?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SapExpression
     */
    isNormal?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    normalityType?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    healthProType?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    findingProcedureRoot?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    siteFindingRoot?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    laterality?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    galenic?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSite?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSiteProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSiteFinding?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSiteFindingProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctAggressor?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctAggressorProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctNestingAggressor?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctAggressorContentProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSubstanceReaction?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctFindingProcedure?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctFindingProcedureProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctNormalityContext?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    ucumUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctAdministrationRoute?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctMorphology?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctBodyQualifier?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctLabCollection?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctCertaintyContext?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctProcedureContext?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctPersonInformer?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctPersonSubject?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSubstance1?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSubstance1Term?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSubstance2?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSubstance2Term?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctContentFamily2?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSubstance3?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSubstance3Term?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctContentFamily3?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSubstance4?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSubstance4Term?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctContentFamily4?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSubstance5?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSubstance5Term?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctContentFamily5?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSubstance6?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctSubstance6Term?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctContentFamily6?: string;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctContentFamily1?: string;
    /**
     * 
     * @type {number}
     * @memberof SapExpression
     */
    sctContentFamily1Index?: number;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctContentFamily1Term?: string;
    /**
     * 
     * @type {number}
     * @memberof SapExpression
     */
    sctContentFamily2Index?: number;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctContentFamily2Term?: string;
    /**
     * 
     * @type {number}
     * @memberof SapExpression
     */
    sctContentFamily3Index?: number;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctContentFamily3Term?: string;
    /**
     * 
     * @type {number}
     * @memberof SapExpression
     */
    sctContentFamily4Index?: number;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctContentFamily4Term?: string;
    /**
     * 
     * @type {number}
     * @memberof SapExpression
     */
    sctContentFamily5Index?: number;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctContentFamily5Term?: string;
    /**
     * 
     * @type {number}
     * @memberof SapExpression
     */
    sctContentFamily6Index?: number;
    /**
     * 
     * @type {string}
     * @memberof SapExpression
     */
    sctContentFamily6Term?: string;
    /**
     * 
     * @type {ExprCclRef}
     * @memberof SapExpression
     */
    expressionCcl?: ExprCclRef;
    /**
     * 
     * @type {ConclusionGroup}
     * @memberof SapExpression
     */
    conclusionGroup?: ConclusionGroup;
    /**
     * 
     * @type {UiIdentifier}
     * @memberof SapExpression
     */
    id: UiIdentifier;
    /**
     * matchedText of the SAP expression (displayed on the button)
     * @type {string}
     * @memberof SapExpression
     */
    text: string;
    /**
     * Medication state icon
     * @type {string}
     * @memberof SapExpression
     */
    icon: string;
    /**
     * Sort order key derived from icon
     * @type {string}
     * @memberof SapExpression
     */
    order: string;
}

/**
 * Check if a given object implements the SapExpression interface.
 */
export function instanceOfSapExpression(value: object): value is SapExpression {
    if (!('expressionId' in value) || value['expressionId'] === undefined) return false;
    if (!('isMatched' in value) || value['isMatched'] === undefined) return false;
    if (!('expressionType' in value) || value['expressionType'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('icon' in value) || value['icon'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function SapExpressionFromJSON(json: any): SapExpression {
    return SapExpressionFromJSONTyped(json, false);
}

export function SapExpressionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SapExpression {
    if (json == null) {
        return json;
    }
    return {
        
        'expressionId': json['expressionId'],
        'conceptGroupId': json['conceptGroupId'] == null ? undefined : json['conceptGroupId'],
        'originalText': json['originalText'] == null ? undefined : json['originalText'],
        'matchedText': json['matchedText'] == null ? undefined : json['matchedText'],
        'unMatchedText': json['unMatchedText'] == null ? undefined : json['unMatchedText'],
        'multiDosageText': json['multiDosageText'] == null ? undefined : json['multiDosageText'],
        'metaDataText': json['metaDataText'] == null ? undefined : json['metaDataText'],
        'languageIso': json['languageIso'] == null ? undefined : json['languageIso'],
        'isMatched': json['isMatched'],
        'expressionType': json['expressionType'],
        'siteRoot': json['siteRoot'] == null ? undefined : json['siteRoot'],
        'siteRootGroup': json['siteRootGroup'] == null ? undefined : json['siteRootGroup'],
        'siteRootGroupIndex': json['siteRootGroupIndex'] == null ? undefined : json['siteRootGroupIndex'],
        'aggressorRoot': json['aggressorRoot'] == null ? undefined : json['aggressorRoot'],
        'aggressorRootGroup': json['aggressorRootGroup'] == null ? undefined : json['aggressorRootGroup'],
        'timelineStart': json['timelineStart'] == null ? undefined : (new Date(json['timelineStart'])),
        'timelineEnd': json['timelineEnd'] == null ? undefined : (new Date(json['timelineEnd'])),
        'durationType': json['durationType'] == null ? undefined : json['durationType'],
        'isNegated': json['isNegated'] == null ? undefined : json['isNegated'],
        'isFamilyHistory': json['isFamilyHistory'] == null ? undefined : json['isFamilyHistory'],
        'isFact': json['isFact'] == null ? undefined : json['isFact'],
        'isNumerical': json['isNumerical'] == null ? undefined : json['isNumerical'],
        'isNormal': json['isNormal'] == null ? undefined : json['isNormal'],
        'normalityType': json['normalityType'] == null ? undefined : json['normalityType'],
        'healthProType': json['healthProType'] == null ? undefined : json['healthProType'],
        'findingProcedureRoot': json['findingProcedureRoot'] == null ? undefined : json['findingProcedureRoot'],
        'siteFindingRoot': json['siteFindingRoot'] == null ? undefined : json['siteFindingRoot'],
        'laterality': json['laterality'] == null ? undefined : json['laterality'],
        'galenic': json['galenic'] == null ? undefined : json['galenic'],
        'sctSite': json['sctSite'] == null ? undefined : json['sctSite'],
        'sctSiteProxy': json['sctSiteProxy'] == null ? undefined : json['sctSiteProxy'],
        'sctSiteFinding': json['sctSiteFinding'] == null ? undefined : json['sctSiteFinding'],
        'sctSiteFindingProxy': json['sctSiteFindingProxy'] == null ? undefined : json['sctSiteFindingProxy'],
        'sctAggressor': json['sctAggressor'] == null ? undefined : json['sctAggressor'],
        'sctAggressorProxy': json['sctAggressorProxy'] == null ? undefined : json['sctAggressorProxy'],
        'sctNestingAggressor': json['sctNestingAggressor'] == null ? undefined : json['sctNestingAggressor'],
        'sctAggressorContentProxy': json['sctAggressorContentProxy'] == null ? undefined : json['sctAggressorContentProxy'],
        'sctSubstanceReaction': json['sctSubstanceReaction'] == null ? undefined : json['sctSubstanceReaction'],
        'sctFindingProcedure': json['sctFindingProcedure'] == null ? undefined : json['sctFindingProcedure'],
        'sctFindingProcedureProxy': json['sctFindingProcedureProxy'] == null ? undefined : json['sctFindingProcedureProxy'],
        'sctNormalityContext': json['sctNormalityContext'] == null ? undefined : json['sctNormalityContext'],
        'sctUnit': json['sctUnit'] == null ? undefined : json['sctUnit'],
        'ucumUnit': json['ucumUnit'] == null ? undefined : json['ucumUnit'],
        'sctAdministrationRoute': json['sctAdministrationRoute'] == null ? undefined : json['sctAdministrationRoute'],
        'sctMorphology': json['sctMorphology'] == null ? undefined : json['sctMorphology'],
        'sctBodyQualifier': json['sctBodyQualifier'] == null ? undefined : json['sctBodyQualifier'],
        'sctLabCollection': json['sctLabCollection'] == null ? undefined : json['sctLabCollection'],
        'sctCertaintyContext': json['sctCertaintyContext'] == null ? undefined : json['sctCertaintyContext'],
        'sctProcedureContext': json['sctProcedureContext'] == null ? undefined : json['sctProcedureContext'],
        'sctPersonInformer': json['sctPersonInformer'] == null ? undefined : json['sctPersonInformer'],
        'sctPersonSubject': json['sctPersonSubject'] == null ? undefined : json['sctPersonSubject'],
        'sctSubstance1': json['sctSubstance1'] == null ? undefined : json['sctSubstance1'],
        'sctSubstance1Term': json['sctSubstance1Term'] == null ? undefined : json['sctSubstance1Term'],
        'sctSubstance2': json['sctSubstance2'] == null ? undefined : json['sctSubstance2'],
        'sctSubstance2Term': json['sctSubstance2Term'] == null ? undefined : json['sctSubstance2Term'],
        'sctContentFamily2': json['sctContentFamily2'] == null ? undefined : json['sctContentFamily2'],
        'sctSubstance3': json['sctSubstance3'] == null ? undefined : json['sctSubstance3'],
        'sctSubstance3Term': json['sctSubstance3Term'] == null ? undefined : json['sctSubstance3Term'],
        'sctContentFamily3': json['sctContentFamily3'] == null ? undefined : json['sctContentFamily3'],
        'sctSubstance4': json['sctSubstance4'] == null ? undefined : json['sctSubstance4'],
        'sctSubstance4Term': json['sctSubstance4Term'] == null ? undefined : json['sctSubstance4Term'],
        'sctContentFamily4': json['sctContentFamily4'] == null ? undefined : json['sctContentFamily4'],
        'sctSubstance5': json['sctSubstance5'] == null ? undefined : json['sctSubstance5'],
        'sctSubstance5Term': json['sctSubstance5Term'] == null ? undefined : json['sctSubstance5Term'],
        'sctContentFamily5': json['sctContentFamily5'] == null ? undefined : json['sctContentFamily5'],
        'sctSubstance6': json['sctSubstance6'] == null ? undefined : json['sctSubstance6'],
        'sctSubstance6Term': json['sctSubstance6Term'] == null ? undefined : json['sctSubstance6Term'],
        'sctContentFamily6': json['sctContentFamily6'] == null ? undefined : json['sctContentFamily6'],
        'sctContentFamily1': json['sctContentFamily1'] == null ? undefined : json['sctContentFamily1'],
        'sctContentFamily1Index': json['sctContentFamily1Index'] == null ? undefined : json['sctContentFamily1Index'],
        'sctContentFamily1Term': json['sctContentFamily1Term'] == null ? undefined : json['sctContentFamily1Term'],
        'sctContentFamily2Index': json['sctContentFamily2Index'] == null ? undefined : json['sctContentFamily2Index'],
        'sctContentFamily2Term': json['sctContentFamily2Term'] == null ? undefined : json['sctContentFamily2Term'],
        'sctContentFamily3Index': json['sctContentFamily3Index'] == null ? undefined : json['sctContentFamily3Index'],
        'sctContentFamily3Term': json['sctContentFamily3Term'] == null ? undefined : json['sctContentFamily3Term'],
        'sctContentFamily4Index': json['sctContentFamily4Index'] == null ? undefined : json['sctContentFamily4Index'],
        'sctContentFamily4Term': json['sctContentFamily4Term'] == null ? undefined : json['sctContentFamily4Term'],
        'sctContentFamily5Index': json['sctContentFamily5Index'] == null ? undefined : json['sctContentFamily5Index'],
        'sctContentFamily5Term': json['sctContentFamily5Term'] == null ? undefined : json['sctContentFamily5Term'],
        'sctContentFamily6Index': json['sctContentFamily6Index'] == null ? undefined : json['sctContentFamily6Index'],
        'sctContentFamily6Term': json['sctContentFamily6Term'] == null ? undefined : json['sctContentFamily6Term'],
        'expressionCcl': json['expressionCcl'] == null ? undefined : ExprCclRefFromJSON(json['expressionCcl']),
        'conclusionGroup': json['conclusionGroup'] == null ? undefined : ConclusionGroupFromJSON(json['conclusionGroup']),
        'id': UiIdentifierFromJSON(json['id']),
        'text': json['text'],
        'icon': json['icon'],
        'order': json['order'],
    };
}

export function SapExpressionToJSON(json: any): SapExpression {
    return SapExpressionToJSONTyped(json, false);
}

export function SapExpressionToJSONTyped(value?: SapExpression | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expressionId': value['expressionId'],
        'conceptGroupId': value['conceptGroupId'],
        'originalText': value['originalText'],
        'matchedText': value['matchedText'],
        'unMatchedText': value['unMatchedText'],
        'multiDosageText': value['multiDosageText'],
        'metaDataText': value['metaDataText'],
        'languageIso': value['languageIso'],
        'isMatched': value['isMatched'],
        'expressionType': value['expressionType'],
        'siteRoot': value['siteRoot'],
        'siteRootGroup': value['siteRootGroup'],
        'siteRootGroupIndex': value['siteRootGroupIndex'],
        'aggressorRoot': value['aggressorRoot'],
        'aggressorRootGroup': value['aggressorRootGroup'],
        'timelineStart': value['timelineStart'] == null ? undefined : ((value['timelineStart'] as any).toISOString()),
        'timelineEnd': value['timelineEnd'] == null ? undefined : ((value['timelineEnd'] as any).toISOString()),
        'durationType': value['durationType'],
        'isNegated': value['isNegated'],
        'isFamilyHistory': value['isFamilyHistory'],
        'isFact': value['isFact'],
        'isNumerical': value['isNumerical'],
        'isNormal': value['isNormal'],
        'normalityType': value['normalityType'],
        'healthProType': value['healthProType'],
        'findingProcedureRoot': value['findingProcedureRoot'],
        'siteFindingRoot': value['siteFindingRoot'],
        'laterality': value['laterality'],
        'galenic': value['galenic'],
        'sctSite': value['sctSite'],
        'sctSiteProxy': value['sctSiteProxy'],
        'sctSiteFinding': value['sctSiteFinding'],
        'sctSiteFindingProxy': value['sctSiteFindingProxy'],
        'sctAggressor': value['sctAggressor'],
        'sctAggressorProxy': value['sctAggressorProxy'],
        'sctNestingAggressor': value['sctNestingAggressor'],
        'sctAggressorContentProxy': value['sctAggressorContentProxy'],
        'sctSubstanceReaction': value['sctSubstanceReaction'],
        'sctFindingProcedure': value['sctFindingProcedure'],
        'sctFindingProcedureProxy': value['sctFindingProcedureProxy'],
        'sctNormalityContext': value['sctNormalityContext'],
        'sctUnit': value['sctUnit'],
        'ucumUnit': value['ucumUnit'],
        'sctAdministrationRoute': value['sctAdministrationRoute'],
        'sctMorphology': value['sctMorphology'],
        'sctBodyQualifier': value['sctBodyQualifier'],
        'sctLabCollection': value['sctLabCollection'],
        'sctCertaintyContext': value['sctCertaintyContext'],
        'sctProcedureContext': value['sctProcedureContext'],
        'sctPersonInformer': value['sctPersonInformer'],
        'sctPersonSubject': value['sctPersonSubject'],
        'sctSubstance1': value['sctSubstance1'],
        'sctSubstance1Term': value['sctSubstance1Term'],
        'sctSubstance2': value['sctSubstance2'],
        'sctSubstance2Term': value['sctSubstance2Term'],
        'sctContentFamily2': value['sctContentFamily2'],
        'sctSubstance3': value['sctSubstance3'],
        'sctSubstance3Term': value['sctSubstance3Term'],
        'sctContentFamily3': value['sctContentFamily3'],
        'sctSubstance4': value['sctSubstance4'],
        'sctSubstance4Term': value['sctSubstance4Term'],
        'sctContentFamily4': value['sctContentFamily4'],
        'sctSubstance5': value['sctSubstance5'],
        'sctSubstance5Term': value['sctSubstance5Term'],
        'sctContentFamily5': value['sctContentFamily5'],
        'sctSubstance6': value['sctSubstance6'],
        'sctSubstance6Term': value['sctSubstance6Term'],
        'sctContentFamily6': value['sctContentFamily6'],
        'sctContentFamily1': value['sctContentFamily1'],
        'sctContentFamily1Index': value['sctContentFamily1Index'],
        'sctContentFamily1Term': value['sctContentFamily1Term'],
        'sctContentFamily2Index': value['sctContentFamily2Index'],
        'sctContentFamily2Term': value['sctContentFamily2Term'],
        'sctContentFamily3Index': value['sctContentFamily3Index'],
        'sctContentFamily3Term': value['sctContentFamily3Term'],
        'sctContentFamily4Index': value['sctContentFamily4Index'],
        'sctContentFamily4Term': value['sctContentFamily4Term'],
        'sctContentFamily5Index': value['sctContentFamily5Index'],
        'sctContentFamily5Term': value['sctContentFamily5Term'],
        'sctContentFamily6Index': value['sctContentFamily6Index'],
        'sctContentFamily6Term': value['sctContentFamily6Term'],
        'expressionCcl': ExprCclRefToJSON(value['expressionCcl']),
        'conclusionGroup': ConclusionGroupToJSON(value['conclusionGroup']),
        'id': UiIdentifierToJSON(value['id']),
        'text': value['text'],
        'icon': value['icon'],
        'order': value['order'],
    };
}

